import(/* webpackMode: "eager" */ "/vercel/path0/components/Banner/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Card/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/OurServices/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Workflow/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/WhyUs/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/AboutUs/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Testimonials/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Testimony/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/Map/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
